import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import Surtitle from "@project/components/Surtitle";
const Presentation = (props) => {
    const { page } = props;
    const { shortDescription, contents } = page || {};
    const { presentationDynamic, title, subtitle } = contents;
    return (_jsxs(Box, { sx: {
            position: "relative",
            overflow: "hidden",
            backgroundColor: "background.header",
            "& .MuiButton-containedPrimary": {
                backgroundColor: "primary.contrastText",
                color: "primary.main",
                "&:hover": {
                    backgroundColor: "primary.contrastText",
                },
            },
            "& .MuiButton-outlinedPrimary": {
                color: "primary.contrastText",
                borderColor: "primary.contrastText",
            },
            "&::before": {
                content: '""',
                position: "absolute",
                background: {
                    xs: "linear-gradient(0deg, hsla(240, 100%, 50%, 0.25) 0%, #0000FF 100%, hsla(240, 100%, 50%, 0.25) 100%)",
                    md: "linear-gradient(90deg, hsla(240, 100%, 50%, 0.25) 0%, #0000FF 50%, hsla(240, 100%, 50%, 0.25) 100%)",
                },
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                inset: 0,
                zIndex: 1,
            },
        }, children: [_jsxs("picture", { children: [_jsx("source", { media: "(max-width: 899px)", srcSet: "/pattern-mobile.svg" }), _jsx(Box, { component: "img", src: "/pattern.svg", alt: "", loading: "eager", fetchPriority: "high", sx: {
                            position: "absolute",
                            inset: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            zIndex: 0,
                        } })] }), _jsxs(Container, { sx: {
                    position: "relative",
                    zIndex: 2,
                    py: { xs: "60px", md: "120px" },
                }, children: [_jsxs(Stack, { spacing: 2, sx: {
                            alignItems: "center",
                            textAlign: "center",
                            justifyContent: "center",
                            maxWidth: "800px",
                            margin: "0 auto",
                        }, children: [subtitle && (_jsx(Surtitle, { title: subtitle, component: "p", contrast: true, withRightBand: true })), _jsxs(Stack, { spacing: 3, sx: {
                                    alignItems: "center",
                                }, children: [_jsx(Typography, { variant: "h1", sx: {
                                            color: "primary.contrastText",
                                            fontSize: { xs: "28px", sm: "44px" },
                                            lineHeight: "120%",
                                        }, children: title }), _jsx(Typography, { variant: "subtitle1", component: "p", sx: {
                                            color: "primary.contrastText",
                                            "& *": {
                                                color: "primary.contrastText",
                                                fontSize: "18px",
                                                fontWeight: 400,
                                                maxWidth: "552px",
                                            },
                                        }, children: shortDescription })] })] }), presentationDynamic] })] }));
};
export default Presentation;
